import { useEffect, useState } from "react";
// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  Alert,
  Paper,
  Select,
  FormControl,
  MenuItem,
  TextField,
} from "@mui/material";
import { styled } from "@mui/system";

import { LIST_POST } from "../../config/const";
// jotai
import { useWindowSize } from "../../lib/useWindowSize";

const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px", // ここでフォントサイズを指定
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};

interface FollowCallConfigCopyModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  copyDataInf: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
    follow_call_entry_status_conf: number | null;
    follow_call_entry_status: string;
    follow_call_base_day_conf: number | null;
    follow_call_day_offset: number | null;
  };
  setCopyDataInf: (value: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
    follow_call_entry_status_conf: number | null;
    follow_call_entry_status: string;
    follow_call_base_day_conf: number | null;
    follow_call_day_offset: number | null;
  }) => void;
  copyData: () => void;
}

export function FollowCallConfigCopyModal(
  props: FollowCallConfigCopyModalProps
) {
  const { onModal, swCloseModal, copyDataInf, setCopyDataInf, copyData } =
    props;

  const { windowWidth, windowHeight } = useWindowSize();

  const [disabledBottun, setDisabledBottun] = useState(true);
  useEffect(() => {
    let disabledBottun = false;
    if (copyDataInf.follow_call_entry_status_conf === null) {
      disabledBottun = true;
    }
    if (
      copyDataInf.follow_call_entry_status_conf === 1 &&
      copyDataInf.follow_call_entry_status === ""
    ) {
      disabledBottun = true;
    }
    if (copyDataInf.follow_call_base_day_conf === null) {
      disabledBottun = true;
    }
    if (copyDataInf.follow_call_day_offset === null) {
      disabledBottun = true;
    }
    setDisabledBottun(disabledBottun);
  }, [copyDataInf]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 568 ? "500px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="cancelTitleBox"
          className="shippori-antique-regular"
        >
          フォローコール設定のコピー
        </Box>
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
          {copyDataInf.status === "open" ? (
            <>
              <Paper elevation={0}>
                <Box
                  key="open1"
                  sx={{
                    maxHeight:
                      windowWidth > 385 ? "calc(70vh - 100px)" : undefined,
                    overflowY: windowWidth > 385 ? "auto" : undefined,
                  }}
                >
                  <Box className="serch-label">エントリーステータスの指定</Box>
                  <Box key="servicePlanBox">
                    <FormControl
                      fullWidth
                      sx={{
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "5px",
                        width: "calc(100% - 10px)",
                      }}
                    >
                      <Select
                        labelId="serch-input-label"
                        id="serch-input-option"
                        key={"servicePlanSelect"}
                        value={copyDataInf.follow_call_entry_status_conf}
                        onChange={(e) => {
                          const follow_call_entry_status_conf = e.target
                            .value as number;
                          setCopyDataInf({
                            ...copyDataInf,
                            follow_call_entry_status_conf,
                            follow_call_entry_status: "",
                          });
                        }}
                        sx={{
                          height: "30px",
                          textAlign: "end",
                          fontSize: "14px",
                        }}
                      >
                        {LIST_POST.follow_call_entry_status_conf.map(
                          (follow_call, i) => {
                            return (
                              <MenuItem
                                key={"follow_call_entry_status_conf" + i}
                                value={follow_call.id}
                                sx={{
                                  fontSize: "14px",
                                  height:
                                    follow_call.value === "" ? "14px" : "24px",
                                  minHeight: "auto",
                                }}
                              >
                                {follow_call.value}
                              </MenuItem>
                            );
                          }
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box className="serch-label">エントリーステータス</Box>
                  <Box key="hope_call_time">
                    <CustomTextField
                      disabled={copyDataInf.follow_call_entry_status_conf === 0}
                      id="hope_call_time"
                      size="small"
                      value={copyDataInf.follow_call_entry_status}
                      onChange={async (e) => {
                        setCopyDataInf({
                          ...copyDataInf,
                          follow_call_entry_status: e.target.value,
                        });
                      }}
                      sx={{
                        width: "calc(100% - 10px)",
                        margin: "10px 5px",
                      }}
                    />
                  </Box>
                </Box>
                <Box className="serch-label">基準日</Box>
                <Box key="servicePlanBox">
                  <FormControl
                    fullWidth
                    sx={{
                      marginTop: "10px",
                      marginBottom: "20px",
                      marginLeft: "5px",
                      width: "calc(100% - 10px)",
                    }}
                  >
                    <Select
                      labelId="serch-input-label"
                      id="serch-input-option"
                      key={"servicePlanSelect"}
                      value={copyDataInf.follow_call_base_day_conf}
                      onChange={(e) => {
                        const follow_call_base_day_conf = e.target
                          .value as number;
                        let follow_call_day_offset =
                          copyDataInf.follow_call_day_offset;
                        if (
                          (follow_call_day_offset ||
                            follow_call_day_offset === 0) &&
                          (follow_call_base_day_conf === 0 ||
                            follow_call_base_day_conf === 1) &&
                          follow_call_day_offset < 1
                        ) {
                          follow_call_day_offset = null;
                        }
                        setCopyDataInf({
                          ...copyDataInf,
                          follow_call_base_day_conf,
                          follow_call_day_offset,
                        });
                      }}
                      sx={{
                        height: "30px",
                        textAlign: "end",
                        fontSize: "14px",
                      }}
                    >
                      {LIST_POST.follow_call_base_day_conf.map(
                        (follow_call, i) => {
                          return (
                            <MenuItem
                              key={"follow_call_base_day_conf" + i}
                              value={follow_call.id}
                              sx={{
                                fontSize: "14px",
                                height:
                                  follow_call.value === "" ? "14px" : "24px",
                                minHeight: "auto",
                              }}
                            >
                              {follow_call.value}
                            </MenuItem>
                          );
                        }
                      )}
                    </Select>
                  </FormControl>
                </Box>
                <Box className="serch-label">日時設定</Box>
                <Box key="servicePlanBox">
                  <FormControl
                    fullWidth
                    sx={{
                      marginTop: "10px",
                      marginBottom: "20px",
                      marginLeft: "5px",
                      width: "calc(100% - 10px)",
                    }}
                  >
                    <Select
                      labelId="serch-input-label"
                      id="serch-input-option"
                      key={"servicePlanSelect"}
                      value={copyDataInf.follow_call_day_offset}
                      onChange={(e) => {
                        const follow_call_day_offset = e.target.value as number;
                        setCopyDataInf({
                          ...copyDataInf,
                          follow_call_day_offset,
                        });
                      }}
                      sx={{
                        height: "30px",
                        textAlign: "end",
                        fontSize: "14px",
                      }}
                    >
                      {copyDataInf.follow_call_base_day_conf === 2
                        ? LIST_POST.follow_call_day_offset_open.map(
                            (follow_call, i) => {
                              return (
                                <MenuItem
                                  key={"follow_call_day_offset" + i}
                                  value={follow_call.id}
                                  sx={{
                                    fontSize: "14px",
                                    height:
                                      follow_call.value === ""
                                        ? "14px"
                                        : "24px",
                                    minHeight: "auto",
                                  }}
                                >
                                  {follow_call.value}
                                </MenuItem>
                              );
                            }
                          )
                        : LIST_POST.follow_call_day_offset.map(
                            (follow_call, i) => {
                              return (
                                <MenuItem
                                  key={"follow_call_day_offset" + i}
                                  value={follow_call.id}
                                  sx={{
                                    fontSize: "14px",
                                    height:
                                      follow_call.value === ""
                                        ? "14px"
                                        : "24px",
                                    minHeight: "auto",
                                  }}
                                >
                                  {follow_call.value}
                                </MenuItem>
                              );
                            }
                          )}
                    </Select>
                  </FormControl>
                </Box>
              </Paper>
              <Box
                key="shozaiSelect"
                style={{ display: windowWidth > 385 ? "flex" : undefined }}
              >
                <Box
                  style={{
                    marginTop: "10px",
                    height: "40px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: windowWidth > 385 ? undefined : "5px",
                  }}
                >
                  <Button
                    disabled={disabledBottun}
                    variant="contained"
                    style={{
                      height: "40px",
                      width: "100%",
                      textTransform: "none",
                    }}
                    onClick={copyData}
                  >
                    <Box className="m-plus-rounded-1c-regular">コピー</Box>
                  </Button>
                </Box>
                <Box
                  style={{
                    marginTop: "10px",
                    height: "40px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: windowWidth > 385 ? "10px" : "5px",
                  }}
                >
                  <Button
                    variant="contained"
                    style={{
                      height: "40px",
                      width: "100%",
                      textTransform: "none",
                    }}
                    onClick={() => {
                      swCloseModal();
                    }}
                  >
                    <Box className="m-plus-rounded-1c-regular">戻る</Box>
                  </Button>
                </Box>
              </Box>
            </>
          ) : copyDataInf.status === "success" ? (
            <>
              <Box className="shippori-antique-regular">成功しました。</Box>
              <Box>
                <Button
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={swCloseModal}
                >
                  <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                </Button>
              </Box>
            </>
          ) : copyDataInf.status === "failed" ? (
            <>
              <Box className="shippori-antique-regular">
                {copyDataInf.message}
              </Box>
              <Box>
                <Button
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={() =>
                    setCopyDataInf({
                      ...copyDataInf,
                      status: "open",
                      message: "",
                    })
                  }
                >
                  <Box className="m-plus-rounded-1c-regular">戻る</Box>
                </Button>
              </Box>
            </>
          ) : null}
        </Typography>
      </Box>
    </Modal>
  );
}
